<template>
  <div class="delete-giveaway-wrapper">
    <h5>Вы действительно хотите удалить этот розыгрыш?</h5>
    <p class="text-muted">Вместе с ним будут удалены все его купоны и победители.</p>
    <b-alert v-if="errorText" show variant="danger">{{ errorText }}</b-alert>
    <footer>
      <b-button @click="submitForm" :disabled="isLoadingSaveForm" variant="danger">
        {{ isLoadingSaveForm ? 'Удаляем...' : 'Удалить' }}
      </b-button>
    </footer>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "DeleteGiveawayModal",
  props: {
    params: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      isLoadingSaveForm: false,
      errorText: null
    }
  },
  methods: {
    ...mapActions('moduleGiveaways', ['deleteGiveaway']),
    async submitForm() {
      try {
        this.isLoadingSaveForm = true;
        this.errorText = null;
        await this.deleteGiveaway(this.params.id);
        this.$emit('giveawayDeleted');
        this.$emit('closeModal');
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Произошла ошибка при удалении розыгрыша';
      } finally {
        this.isLoadingSaveForm = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.delete-giveaway-wrapper {
  h5 {
    font-size: 16px;
    font-weight: 400;
  }

  footer {
    border-top: 1px solid #dee2e6;
    padding-top: 15px;
    margin-top: 15px;
    text-align: right;
  }
}
</style>
